/*
* CA Disclosure page 2
*/

import * as React from 'react';
import * as _ from 'lodash';
import moment from 'moment';

import * as ReportComponents from '../report-components';
import { Formatters } from '../../../common/formatters';
import ApiEndpoints from '../../../config/apiendpoints';

export const Render = ({ reportData, tableYearSummary, ...rest }) => {
    const {
        currentOrder,
        currentOrderChart,
        currentOrderUsers,
        branding,
        association,
        reportPeriodStartDate,
        reportPeriodEndDate,
        reportPeriodFYEDate,
        reportBeginYear,
        reportBeginYearIdealBalance,
        reportBeginYearStartBalance,
        yearlySummaryData,
        reportParameters,
    } = reportData;

    const { assumptionInterest, assumptionInflation, analysisFundingDeficiencyPerUnit } = reportParameters;

    const buildTextUnderlined = (s: any) => (<span className="pdf-disclosure-page-1-section-text-na">{s}</span>);
    const SeeChartBelowText = '(See Chart Below)';
    const pageSeeChartBelow = buildTextUnderlined(SeeChartBelowText);

    // SECTION 7
    return (
        <ReportComponents.ReportPage className="pdf-disclosure-page-2" reportData={reportData}>
            <div className="pdf-disclosure-page-1-title-container" />

            <div className="pdf-disclosure-page-2-section-container">
                <div className="pdf-disclosure-page-1-section-text">
                    (7) Based on the method of calculation in paragraph (4) of subdivision (b) of Section 5570 of the Civil Code, the estimated amount required in the
                    reserve fund at the end of each of the next five budget years is ${pageSeeChartBelow}, and the projected reserve fund cash balance in each of those
                    years, taking into account only assessments already approved and other known revenues, is ${pageSeeChartBelow}, leaving the reserve at ${pageSeeChartBelow}
                    percent funding. If the reserve funding plan approved by the association is implemented, the projected reserve fund cash balance in each of those years
                    will be ${pageSeeChartBelow}, leaving the reserve at {SeeChartBelowText}, percent funding.  At the time this summary was prepared, the assumed long-term
                    before-tax interest rate earned on reserve funds was <ReportComponents.Percentage value={assumptionInterest} decimals={3} /> percent per year, and
                    the assumed long-term inflation rate to be applied to major component repair and replacement costs was <ReportComponents.Percentage value={assumptionInflation} decimals={3} /> percent per year.
                </div>

                <div className="pdf-disclosure-page-1-section-table">
                    {tableYearSummary}
                </div>

                <div className="pdf-disclosure-page-1-section-text">
                    Note: The financial representations set forth in this summary are based on the best estimates of the preparer at that time. The estimates are subject
                    to change.
                </div>
            </div>

            <div className="pdf-disclosure-page-2-section-container">
                <div className="pdf-disclosure-page-1-section-text">
                    For the purposes of preparing a summary pursuant to this section:
                </div>
            </div>

            <div className="pdf-disclosure-page-2-section-container">
                <div className="pdf-disclosure-page-2-section-text-small">
                    (1) "Estimated remaining useful life" means the time reasonably calculated to remain before a major component will require replacement.
                </div>
            </div>

            <div className="pdf-disclosure-page-2-section-container">
                <div className="pdf-disclosure-page-2-section-text-small">
                    (2) "Major component" has the meaning used in Section 5300. Components with an estimated remaining useful life of more than
                    30 years may be included in a study as a capital asset or disregarded from the reserve calculation, so long as the decision is
                    revealed in the reserve study report and reported in the Assessment and Reserve Funding Disclosure Summary.
                </div>
            </div>

            <div className="pdf-disclosure-page-2-section-container">
                <div className="pdf-disclosure-page-2-section-text-small">
                    (3) The form set out in subdivision (a) shall accompany each annual budget report or summary thereof that is delivered pursuant to
                    Section 5300. The form may be supplemented or modified to clarify the information delivered, so long as the minimum information set
                    out in subdivision (a) is provided.
                </div>
            </div>

            <div className="pdf-disclosure-page-2-section-container">
                <div className="pdf-disclosure-page-2-section-text-small">
                    (4) For the purpose of the report and summary, the amount of reserves needed to be accumulated for a component at a given time
                    shall be computed as the current cost of replacement or repair multiplied by the number of years the component has been in
                    service divided by the useful life of the component. This shall not be construed to require the board to fund reserves in accordance
                    with this calculation.
                </div>
            </div>

            <div className="pdf-disclosure-page-2-section-container">
                <div className="pdf-disclosure-page-2-section-text-small">
                    (5) The board has not determined to defer or not undertake repairs or replacement of any major component with a remaining life of
                    30 years or less.
                </div>
            </div>

            <div className="pdf-disclosure-page-2-section-container">
                <div className="pdf-disclosure-page-2-section-text-small">
                    (6) The board has not determined or anticipates that the levy of one or more special assessments will be required to repair,
                    replace, or restore any major component or to provide adequate reserve to fund same.
                </div>
            </div>

            <div className="pdf-disclosure-page-2-section-container">
                <div className="pdf-disclosure-page-2-section-text-small">
                    (7) The board intends to fund the reserves to repair or replace major components via a regular monthly reserve assessment.
                </div>
            </div>

            <div className="pdf-disclosure-page-2-section-container">
                <div className="pdf-disclosure-page-2-section-text-small">
                    (8) The current deficiency in reserve funding expressed on a per unit basis
                    is <ReportComponents.Currency value={analysisFundingDeficiencyPerUnit} decimals={2} />. { /* reserveBalanceDeficiencyPerUnit} decimals={2} />. */}
                </div>
            </div>
        </ReportComponents.ReportPage>
    );
};



// WEBPACK FOOTER //
// ./src/report/pdf/pages/disclosure-page-2.tsx